// import message from '@/base/components/message/message';
import { useEffect, useState } from 'react';
import { Message } from '@meitu/saas-ui';
import { useLocaleStore } from '../i18n';

export const useNetWork = () => {
    const [online, setOnline] = useState(true);
    const { $t } = useLocaleStore();

    useEffect(() => {
        const updateOnlineStatus = () => {
            if (navigator.onLine) {
                Message.success($t((v) => v.hooks.useNetWork.onLine));
                setOnline(true);
            } else {
                setOnline(false);
                Message.error($t((v) => v.hooks.useNetWork.unOnLine));
            }
        };

        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);
        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    }, []);

    return online;
};
